import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
import { serverEventData } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "fairyJade",
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      reqLoading: false,
      paramsData: {
        page: 1,
        start_time: '',
        end_time: ''
      },
      value2: [],
      exreqLoading: false,
      tableData: [],
      total: 0,
      tableCopyTableList: [],
      typeChange: {
        1: this.$t('bidding'),
        2: this.$t('bidReturn'),
        3: this.$t('successfulAuctionPriceRecordedOnSeller'),
        4: this.$t('handlingFeeRecordedOnSeller'),
        5: this.$t('marketPurchase'),
        6: this.$t('marketSuccessfulSalePriceRecordedOnSeller'),
        7: this.$t('marketHandlingFeeRecordedOnSeller')
      }
    };
  },
  created: function created() {},
  methods: {
    getList: function getList(e) {
      var _this = this;

      if (this.paramsData.server_id.length == 0) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      this.paramsData.page = e;
      this.paramsData.start_time = this.value2[0] || '';
      this.paramsData.end_time = this.value2[1] || '';
      this.reqLoading = true;
      serverEventData(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        game_id: this.rawData.game_id
      })).then(function (res) {
        if (res.status == 200) {
          res.data.map(function (element) {
            element.type = element.ext ? element.ext['type'] : '/';
            element.playerID = element.ext ? element.ext['playerID'] : '/';
            element.uid = element.ext ? element.ext['uid'] : '/';
            element.num = element.ext ? element.ext['num'] : '/';
          });
          _this.tableData = res.data;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var columns, totalPage, list, i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                columns = [{
                  label: _this2.$t('giftId'),
                  prop: 'giftID'
                }, {
                  label: _this2.$t('giftCode'),
                  prop: 'giftCode'
                }, {
                  label: _this2.$t('giftTotalCount'),
                  prop: 'maxCount'
                }, {
                  label: _this2.$t('claimedCount'),
                  prop: 'getCount'
                }, {
                  label: _this2.$t('maxClaimCount'),
                  prop: 'rewardCount'
                }, {
                  label: _this2.$t('startTime'),
                  prop: 'startTime'
                }, {
                  label: _this2.$t('endTime'),
                  prop: 'endTime'
                }];
                totalPage = _this2.total % 15 == 0 ? _this2.total / 15 : _this2.total / 15 + 1;
                _this2.exreqLoading = true;
                list = [];
                i = 0;

              case 5:
                if (!(i < totalPage)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 8;
                return getGiftList(_objectSpread(_objectSpread({}, _this2.paramsData), {}, {
                  page: i + 1
                })).then(function (res) {
                  if (res.status == 200) {
                    list = [].concat(_toConsumableArray(list), _toConsumableArray(res.data.data));
                  }
                });

              case 8:
                i++;
                _context.next = 5;
                break;

              case 11:
                list.map(function (i) {
                  i.startTime = _this2.$times.formDate(i.startTime * 1000);
                  i.endTime = _this2.$times.formDate(i.endTime * 1000);
                });
                _this2.exreqLoading = false;

                _this2.$export.excel({
                  columns: columns,
                  data: list,
                  title: _this2.$route.meta.title
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    deleHandle: function deleHandle(id) {
      var _this3 = this;

      this.$confirm(this.$t('confirmDeleteGift'), this.$t('prompt'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                szgmDelGift({
                  gift_id: id,
                  server_id: _this3.paramsData.server_id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this3.getList(_this3.paramsData.page);

                    _this3.$message({
                      type: "success",
                      message: _this3.$t('deleteSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};